import { render } from "./ChangePackages.vue?vue&type=template&id=2f071bd9&scoped=true"
import script from "./ChangePackages.vue?vue&type=script&lang=js"
export * from "./ChangePackages.vue?vue&type=script&lang=js"

import "@/styles/pages/add-package.scss?vue&type=style&index=0&id=2f071bd9&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f071bd9"]])

export default __exports__